/* ============================================================
   Honeyjoy Paws - Collection Toolbar
   控制商品网格列数 + localStorage 记忆 + 跨页面同步
   + 商品数量同步（监听 facets.js 更新）
   ============================================================ */

(function () {
  'use strict';

  var STORAGE_KEY = 'hjp_collection_view_cols';
  var VALID_COLS = ['2', '3', '4'];

  /* ---------- View Switcher（视图切换） ---------- */

  function getStoredView() {
    try {
      var v = localStorage.getItem(STORAGE_KEY);
      if (VALID_COLS.indexOf(v) !== -1) return v;
    } catch (e) { /* localStorage 可能被禁用 */ }
    return '4'; // 默认 4 列
  }

  function setStoredView(v) {
    try {
      localStorage.setItem(STORAGE_KEY, v);
    } catch (e) { /* silent */ }
  }

  function applyView(cols) {
    // 给 product-grid 容器添加 data-view-cols
    var gridContainer = document.querySelector('.collection');
    if (gridContainer) {
      gridContainer.setAttribute('data-view-cols', cols);
    }
    // 兼容：一些 section 用 page-width container 包裹
    var grid = document.querySelector('#ProductGridContainer');
    if (grid) {
      grid.setAttribute('data-view-cols', cols);
    }

    // 更新按钮 active 状态
    var buttons = document.querySelectorAll('.view-switcher__btn');
    buttons.forEach(function (btn) {
      if (btn.getAttribute('data-cols') === cols) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
      } else {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-pressed', 'false');
      }
    });
  }

  function initViewSwitcher() {
    var switcher = document.querySelector('.view-switcher');
    if (!switcher) return;

    // 初始化为存储的值
    var stored = getStoredView();
    applyView(stored);

    // 绑定按钮点击
    switcher.addEventListener('click', function (e) {
      var btn = e.target.closest('.view-switcher__btn');
      if (!btn) return;
      var cols = btn.getAttribute('data-cols');
      if (!cols || VALID_COLS.indexOf(cols) === -1) return;

      setStoredView(cols);
      applyView(cols);

      // 触发自定义事件，方便后续扩展
      document.dispatchEvent(new CustomEvent('hjp:viewchange', {
        detail: { cols: cols }
      }));
    });
  }

  /* ---------- Product Count Sync（同步商品数量） ----------
     Dawn 的 facets.js 在筛选变化时会更新 #ProductCount 和 #ProductCountDesktop。
     我们的 toolbar 用了不同的 ID #HjpProductCount，需要监听并同步。
  */

  function syncCount() {
    var hjpCount = document.getElementById('HjpProductCount');
    if (!hjpCount) return;

    // 从 #ProductCount 同步
    var src = document.getElementById('ProductCount');
    var srcText = '';
    if (src && src.innerHTML.trim() !== '') {
      srcText = src.textContent || src.innerText || '';
    } else {
      // Fallback: 从 #ProductCountDesktop 同步
      var srcDesktop = document.getElementById('ProductCountDesktop');
      if (srcDesktop && srcDesktop.innerHTML.trim() !== '') {
        srcText = srcDesktop.textContent || srcDesktop.innerText || '';
      }
    }

    if (!srcText) return;

    // 提取第一个数字
    var match = srcText.match(/\d+/);
    if (!match) return;
    var num = match[0];

    // 用 "items" 后缀替换原内容
    hjpCount.innerHTML = '<span class="hjp-count-num">' + num + '</span> items';
  }

  function initCountSync() {
    var hjpCount = document.getElementById('HjpProductCount');
    if (!hjpCount) return;

    // 立即同步一次
    syncCount();

    // 使用 MutationObserver 监听 ProductCount 的更新
    function observeSource(id) {
      var el = document.getElementById(id);
      if (!el) return;
      var observer = new MutationObserver(function () {
        syncCount();
      });
      observer.observe(el, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    observeSource('ProductCount');
    observeSource('ProductCountDesktop');
  }

  /* ---------- Init ---------- */

  function init() {
    initViewSwitcher();
    initCountSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
